










































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import Button from '@/components/common/elements/Button.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import Table from '@/components/common/elements/Table.vue';
import Select from '@/components/common/elements/Select.vue';
import RadioArea from '@/components/common/modules/RadioArea.vue';
import FileManagerForm from '@/components/form/FileManagerForm.vue';
import appState from '@/store/app';

@Component({
  components: {
    InputNoVModel,
    Button,
    SingleText,
    AutoCreateForm,
    Table,
    Select,
    RadioArea,
    FileManagerForm
  },
})
export default class ContractInfomationTab extends Vue {
  inheritAttrs = false;
  @Prop({ default: () => ({}) })
  private item: any;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  private isPersistent?: boolean = true;

  async created() {
    if (appState.options['電子契約有無']['案件詳細'].electronic_contract === 'false') {
      const radioItem = this.item.radioItem.option.options.find((v: any) => {
        if (v.text === '非電子契約') {
          this.item.radioItem.option.options = []
          this.item.radioItem.option.options.push(v);

          return v;
        }
      });
      this.item.radioItem.selectView = radioItem.option_id;
      this.item.radioItem.default = radioItem.option_id;
      const radioItemValue = {
        value: radioItem.option_id
      };
      this.radioItemEvent(radioItemValue);
    }
  }

  // 登録ダイアログ内サンプルダウンロードボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private sampleDownloadButton(response: any) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'sampleDownloadButton';
    return responseData;
  }

  // 電子・非電子契約切替用ラジオボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private radioItemEvent(response: any) {
    response.action = 'contractInfomationTab';
    response.eventName = 'radioItemEvent';
    return response;
  }

  // 詳細ダイヤログ内ダウンロードボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private detailDialogFileDownloadButton(response: any) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'detailDialogFileDownloadButton';
    return responseData;
  }

  // 登録ダイヤログ内入力イベント通知
  @Emit('tabChildrenEventRelay')
  private catchDialogInput(response: any, panelName?: string) {
    response.action = 'contractInfomationTab';
    response.eventName = 'catchDialogInput';
    response.panelName = panelName ? panelName : '';
    return response;
  }

  // 更新するボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private documentManagementTableUpdate(response: any) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'documentManagementTableUpdate';
    return responseData;
  }

  // 登録ダイアログ内署名依頼ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private signatureRequestConfirmationOpen(response: any) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'signatureRequestConfirmationOpen';
    return responseData;
  }

  // 確認ダイアログ内実行ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private signatureRequest(response: any) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'signatureRequest';
    return responseData;
  }

  // 登録ダイアログ内乱数入力ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private randomNumberInputButton(response: any) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'randomNumberInputButton';
    return responseData;
  }

  // 新規登録ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private signatureDialogOpenButton() {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'signatureDialogOpenButton';
    return responseData;
  }

  // 新規登録画面キャンセルボタン
  @Emit('tabChildrenEventRelay')
  private signatureDialogClose() {
    const form: any = this.$refs.observer_form;
    form.reset();
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'signatureDialogClose';
    return responseData;
  }

  // 詳細ダイアログ更新のイベント通知
  @Emit('tabChildrenEventRelay')
  private signatureDetailUpdate() {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'signatureDetailUpdate';
    return responseData;
  }

  // 詳細ダイアログを閉じるイベント通知
  @Emit('tabChildrenEventRelay')
  private signatureDetailDialogClose() {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'signatureDetailDialogClose';
    return responseData;
  }

  // 電子契約一覧のtable内ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private clickTableButton(response: any) {
    response.action = 'contractInfomationTab';
    response.eventName = 'clickTableButton';
    return response;
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @param data - 入力値
   * @param index - 入力行番号
   */
  @Emit('inputOperation')
  public inputOperation(data: any, index?: number) {
    // this.reflectInputValue(index, data.name, data.value);
    this.emit({ data, index });
  }
  
  /**
   * 契約書タイプ選択
   * @param data - 入力値
   * @param index - 入力行番号
   */
  @Emit('tabChildrenEventRelay')
  public selectContractTypeEvent(data: { [k: string]: any }, index?: number) {
    data.action = 'contractInfomationTab';
    data.eventName = 'selectContractTypeEvent';
    return data;
  }

  /**
   * 入力値を反映する
   */
  private reflectInputValue(listIndex: number, targetName: string, reflectValue: any) {
    if (listIndex) {
      this.item.listDatas[listIndex][targetName] = reflectValue;
    } else {
      this.item[targetName] = reflectValue;
    }
  }

  @Emit('tabChildrenEventRelay')
  private emit(response: any) {
    return response;
  }

  // ファイルアップロード関係
  // ファイルマネージャー内リストアクション
  @Emit('tabChildrenEventRelay')
  private nonContractListAction(response: any) {
    response.action = 'contractInfomationTab';
    response.eventName = 'nonContractListAction';
    return response;
  }

  // ファイルマネージャー内ファイル選択
  @Emit('tabChildrenEventRelay')
  private setNonContractInputFiles(files: File[]) {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'setNonContractInputFiles';
    responseData.files = files;
    return responseData;
  }

  @Emit('tabChildrenEventRelay')
  private nonContractFileUpload() {
    const responseData: any = {};
    responseData.action = 'contractInfomationTab';
    responseData.eventName = 'nonContractFileUpload';
    return responseData;
  }

  // ファイルマネージャー内実行ボタン制御
  private setSubmitDisable(invalid: boolean, errors: { [x: string]: string[] }): boolean {
    let obj: string[] = [];
    for (const [key, value] of Object.entries(errors)) {
      if (value.length > 0) {
        obj = [...obj, key];
      }
    }
    let passFlg = false;
    if (obj.length === 1 && obj[0] === 'count') {
      passFlg = true;
    }

    if (this.item.nonContractinputFiles && this.item.nonContractinputFiles.length === 0)
      return true;
    if (passFlg) return false;
    return invalid;
  }

}
